import { ButtonHTMLAttributes, forwardRef } from 'react';
import { Loader2 } from 'lucide-react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  loading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', loading = false, disabled, children, className = '', ...props }, ref) => {
    const baseStyles = 'inline-flex items-center justify-center gap-2 px-6 py-3 rounded-[14px] font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none';
    
    const variantStyles = {
      primary: 'bg-[#FF6A2A] text-white hover:bg-[#C2410C] focus:ring-[#FF6A2A] shadow-sm',
      secondary: 'bg-white text-[#111827] hover:bg-[#F7F8FA] focus:ring-[#6B7280] border border-[#E5E7EB]',
      ghost: 'bg-transparent text-[#111827] hover:bg-[#F7F8FA] focus:ring-[#6B7280]',
    };

    return (
      <button
        ref={ref}
        disabled={disabled || loading}
        className={`${baseStyles} ${variantStyles[variant]} ${className}`}
        {...props}
      >
        {loading && <Loader2 className="w-5 h-5 animate-spin" />}
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';